/* template */
<template minapp="mpx" xlang="wxml"><from-item :isShow="(isShow)" :isRequired="(isRequired)" :isRequiredShow="(isRequiredShow)" label="姓名" :innerValue="(innerValue)" :nameTips="(nameTips)" :isDisable="(isNameDisable)"><mpx-input fixed :class="(isFieldClass)" :value="innerValue" mpxModelEvent="input" @mpxModel='__model("innerValue", $event, ["value"], undefined)' type="text" :maxlength="(52)" placeholder="请填写真实姓名" @blur="nameBoxBlur" slot="input"/></from-item></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0b145aa0"}'>
  +b('content')
    +e('input')
      box-sizing border-box
      width calc(100% - 6px)
      height 24px
      resize none
      background-color transparent
      text-align left
      line-height 24px
      -webkit-appearance none //是为了去除内阴影样式，但是缺点是不可输入；
      -webkit-user-select auto// 解决输入问题
    +e('show-btn')
      width calc(100% - 82px)
      
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0b145aa0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./contact-name12306.mpx.js?isComponent&outputPath=components%2Fcontact-name123060b145aa0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./contact-name12306.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcontact-name123060b145aa0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0b145aa0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/contact-name123060b145aa0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex")),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
